
import { useMutation, useQuery } from "react-query"
import { useToast } from "../../../hook/usetoast";
import DataService from '../../../config/DataServices'

const { postRequest,getRequest} = DataService()






export const useGetFaq = () => {

    return useQuery({
        queryKey: ["get-faq"],
        queryFn: () => {
            return getRequest(`user/auth/getFaqUser`)
        },

    })
}
export const useGetCms = () => {

    return useQuery({
        queryKey: ["get-cms"],
        queryFn: () => {
            return getRequest(`user/auth/getCms`)
        }
    })
}

 

export const useGetRoad = () => {

    return useQuery({
        queryKey: ["get-road"],
        queryFn: () => {
            return getRequest(`user/auth/getRoad`)
        }
    })
}


export const useGetCount = () => {

    return useQuery({
        queryKey: ["get-count"],
        queryFn: () => {
            return getRequest(`user/auth/getTotalUsers`)
        }
    })
}



export const useConnectWallet = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/auth/metamaskLogin", {...data})
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }

            return toast.success(success?.message)
        }
    })
}
export const useBeforeconnect = () => {
    const toast =useToast()

    return useMutation({
        mutationFn: data => {
            return postRequest("user/auth/beforeLogin", {...data})
        },
        onSuccess: success => {

            if (success?.message === 'Invalid referral code') {
                  return toast.error(success?.message)
            }
            
        }
    })
}

export const useMetamaskDisconnect = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/auth/metamask-logout", {...data})
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }

            return toast.success(success?.message)
        }
    })
}

export const useUserStatusCheck = () => {

    return useMutation({
        mutationFn: data => {
            return postRequest("user/auth/checkLoggedIn", {...data})
        },
        
    })
}




export const useGetAirDropTimer = () => {
    const jwt = sessionStorage.getItem('user_JWT');

    const mutation = useMutation({
        mutationFn: (data) => {
            if (!jwt) {
                return Promise.reject('JWT is missing');
            }
            return postRequest('user/auth/getUserProfile', { ...data });
        },
    });

    return mutation;
};


//festival Offer

export const useGetFestivalOffer = ({type}) => {

    return useQuery({
        queryKey: ['get-festivalOffer',type],
        queryFn: () => {
            return getRequest(`user/auth/get-banner?type=${type}`)
        },
    })
}